// extracted by mini-css-extract-plugin
export default {"ChevronStyle":"generalStyles_ChevronStyle__jWOS4","imageContainer":"generalStyles_imageContainer__+azFl","image":"generalStyles_image__EU1zk"};